import { useRef, useState } from "react";

import { Button, InputLabel, OutlinedInput } from "@mui/material";
import { BeatLoader } from 'react-spinners';

import "./index.css";
import { useAuth } from "../../context/authContext";
import AlertSnack from "../../components/Alert/AlertSnack";
import { useLists } from "../../context/listContext";
// import { loginAdmin } from "../../api/admin.api";

const Login = () => {
  const { loginAdmin } = useAuth();
  const { setRefresh } = useLists();
  const userEmail = useRef();
  const password = useRef();
  const [ loading, setLoading ] = useState(false);
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});

  const loginHandler = async () => {

    console.log("login handler");
    try {
      setLoading(true);
      const submit = await loginAdmin({ email: userEmail.current.value, password: password.current.value}, () => setRefresh(prev => !prev));
      setResponse(submit);
      setOpen(true);
    //   navigate('/myaccount')
        console.log('success');
    } catch (err) {
      setOpen(true);
        console.log(err)
      console.log("failure");
    }
    setLoading(false);
  }

  return (
    <div className="container-own">
    {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="dashboard"/>}
      <main className="main">
        <div className="grid center-text">
          <h2 className="text-2xl ">Login to your account</h2>
        {loading ?
          <>
            <p className="description">
              Processing..
            </p>
            <div className='items-center'>
              <BeatLoader color="#36d7b7" />
            </div>
          </>
          :  
          <>
          <div className="loginBox">
            <div>
              <InputLabel htmlFor="userEmail">Email Address: </InputLabel>
              <OutlinedInput
                fullWidth
                name="userEmail"
                id="userEmail"
                inputRef={userEmail}
                type="email"
                placeholder="Enter Your Email Address"
                />
            </div>
            <div>
            <InputLabel htmlFor="password">Password: </InputLabel>
            <OutlinedInput
                fullWidth
                name="password"
                id="password"
                inputRef={password}
                type="password"
                placeholder="Enter Your Password"
                />
            </div>
            <Button
              fullWidth
              variant="outlined"
              type="button"
              color="info"
              onClick={loginHandler}
            >
              Log In
            </Button>
          </div>
        </>}
        </div>
      </main>
    </div>
  );
};

export default Login;
